import React from 'react'
import { Toaster, ToasterProps } from 'sonner'
import './toaster.scss'

const toasterConfiguration: Partial<ToasterProps> = {
    closeButton: true,
    className: 'toaster',
    offset: {
        right: 85,
    },
    toastOptions: {
        classNames: {
            toast: 'toast',
            title: 'toast-title',
            description: 'toast-description',
            loader: 'toast-loader',
            closeButton: 'toast-close-button',
            cancelButton: 'toast-cancel-button',
            actionButton: 'toast-action-button',
            success: 'toast-success',
            error: 'toast-error',
            info: 'toast-info',
            warning: 'toast-warning',
            loading: 'toast-loading',
            default: 'toast-default',
            content: 'toast-content',
            icon: 'toast-icon',
        },
    },
}

export const ConfiguredToaster = () => {
    return <Toaster {...toasterConfiguration} />
}
